import { BaseService } from "@kiddocare-platform/portal-common/base";
import type { AxiosRequestHeaders } from "axios";

export class RepositoryCertificatesService extends BaseService {
	public async UploadDocument(ticket: string, name: string, file: File): Promise<unknown> {
		try {
			const body = new FormData();
			body.append("media", file, file.name);

			const response = await this.AxiosInstance.post(`/parent/certificates/uploadDocument/${ticket}/${encodeURIComponent(name)}`, body,
				{
					headers: {
						Accept: "application/json",
					},
					// Il BaseService imposta di default "Content-Type: application/json".
					// Per le FormData dobbiamo lasciare che il browser generi il Content-Type
					// completo di boundary, altrimenti multer non trova i file e ritorna
					// "Cannot read properties of undefined (reading '0')".
					transformRequest: [
						(data, headers) => {
							if (headers) {
								const h = headers as AxiosRequestHeaders & Record<string, unknown>;
								delete h["Content-Type"];
								delete h["content-type"];
							}
							return data;
						},
					],
				},
			);
			return response.data;
		} catch (error: any) {
			this.log.error("UploadDocument", error?.stack ?? String(error));
			throw error?.response?.data?.error ? error.response.data.error : error;
		}
	}

	public async GetCertificate(ticket: string): Promise<ArrayBuffer> {
		try {
			const response = await this.AxiosInstance.get(`/parent/certificates/${ticket}`, {
				responseType: "arraybuffer",
			});
			return response.data;
		} catch (error: any) {
			this.log.error("GetCertificate", error?.stack ?? String(error));
			throw error;
		}
	}

	public async GetDocument(ticket: string, key: string): Promise<Blob> {
		try {
			const response = await this.AxiosInstance.get(`/parent/certificates/document/${ticket}/${key}`, {
				responseType: "blob",
			});
			return response.data;
		} catch (error: any) {
			this.log.error("GetDocument", error?.stack ?? String(error));
			throw error;
		}
	}
}